// extracted by mini-css-extract-plugin
module.exports = {"container":"Services_container__1SWB7","cardsContainer":"Services_cardsContainer__wK4ru"};